import { useEffect, useState } from 'react'
import clsx from 'clsx'
import { isBefore } from 'date-fns'

import { Popup } from '@/ui/Popup'
import { DatePicker } from '@/ui/DatePicker'
import { formatDate } from '../utils/formatDate'
import { useDateStore } from '../store'

import styles from './DateInput.module.scss'

import ArrowIcon from '../assets/arrow.svg'

const POPUP_OFFSET = 12

interface Props {
    disableDateFrom?: Date
    disabled?: boolean
}

const updateDate = (storedDate: string, disableDateFrom?: Date): Date => {
    const init = storedDate ? new Date(storedDate) : new Date()

    if (!disableDateFrom || isBefore(init, disableDateFrom)) {
        return init
    }

    return disableDateFrom
}

export const DateInput = ({ disableDateFrom, disabled = false }: Props) => {
    const { date, setDate } = useDateStore()
    const [selectedDate, setSelectedDate] = useState(updateDate(date, disableDateFrom))

    const handleDateChange = (date: Date) => {
        setSelectedDate(date)
        setDate(date)
    }

    useEffect(() => {
        setSelectedDate(updateDate(date, disableDateFrom))
    }, [date, disableDateFrom])

    return disabled ? (
        <div className={clsx(styles.selectContainer, styles.disabled)}>
            <span className={styles.label}>{formatDate(selectedDate)}</span>
        </div>
    ) : (
        <Popup
            offset={POPUP_OFFSET}
            placement="bottom-start"
            className={styles.popup}
            triggerComponent={(isOpen) => (
                <div className={styles.selectContainer}>
                    <span className={styles.label}>{formatDate(selectedDate)}</span>
                    <button className={clsx(styles.triggerButton, { [styles.open]: isOpen })}>
                        <ArrowIcon />
                    </button>
                </div>
            )}
        >
            <DatePicker value={selectedDate} disableDateFrom={disableDateFrom} onChange={handleDateChange} />
        </Popup>
    )
}
